import { shouldShowCguModal } from '@domain/legal/CguAcceptance';
import { CGU_VERSION } from '@domain/legal/CguVersion';
import { acceptCgu, getLatestCguAcceptance } from '@infra/legal/CguAcceptanceStore';
import { appendTrialUsageAction, startTrialUsageSession } from '@infra/legal/TrialUsageStore';
import { presentCguModal } from '@presentation/legal/CguModal';

export interface CguGateInput {
  userId: string;
  isTrial: boolean;
}

/**
 * Vérifie silencieusement l’acceptation CGU.
 * N’affiche le modal qu’à la première utilisation (ou nouvelle version).
 * Retourne false si l’utilisateur décline (session bloquée).
 */
export async function enforceCguGate(host: HTMLElement, input: CguGateInput): Promise<boolean> {
  const latest = await getLatestCguAcceptance(input.userId);
  if (!shouldShowCguModal(latest, CGU_VERSION)) {
    await startTrialUsageSession({ user_id: input.userId, is_trial: input.isTrial });
    await appendTrialUsageAction('app.session_start');
    return true;
  }

  const decision = await presentCguModal(host);
  if (decision !== 'accepted') return false;

  await acceptCgu({
    user_id: input.userId,
    version_cgu: CGU_VERSION,
    is_trial: input.isTrial,
  });
  await startTrialUsageSession({ user_id: input.userId, is_trial: input.isTrial });
  await appendTrialUsageAction('app.session_start');
  return true;
}
